<template>

  <v-treeview
    :hoverable="true"
    :items="tree"
    :open="opened"
    item-key="id"
    item-text="name"
    item-children="children"
  >
    <template v-slot:label="{ item }">
      <div @click="$emit('click', item)" class="item-label">{{ item.name }}</div>
    </template>

    <template v-slot:append="{ item }">
      <a @click.prevent="$emit('click', item)">
        <font-awesome-icon icon="pen"></font-awesome-icon>
      </a>
    </template>
  </v-treeview>

</template>

<script>
  import dataTable from '../../helpers/data-table.es6'
  import TreeModel from '../../../tree-model.es6'

  export default {
    name: 'asset-types-table',

    mixins: [ dataTable ],

    computed: {
      tree () {
        const items = this._items.length ? new TreeModel({ payloads: this._items }).roots() : []
        const map = item => ({ id: item.id, name: item.name, children: item.children.map(map) })

        return items.map(map)
      },

      opened () {
        return this._items.map(item => item.id)
      }
    },

    created () {
      this.refresh()
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  ::v-deep {
    .v-treeview-node {
      cursor: pointer;

      .v-treeview-node__root {
        border-bottom: 1px solid $color-gray;
      }
    }
  }

  .item-label {
    min-height: 48px;
    display: flex;
    align-items: center;
  }

</style>
